<template>
  <div class="bread-crumb">
    <div class="currentPosition">您当前位置：</div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="bread-item">
      <el-breadcrumb-item :to="{ path: '/' }" class="crumb-item">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-if="this.$route.name == 'Entry' && this.$route.query.CategoryA" class="crumb-item" @click.native="handleToBack">{{this.$route.query.CategoryA}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="this.$route.name == 'SearchItem'" class="crumb-item">检索结果页</el-breadcrumb-item>
      <el-breadcrumb-item v-if="this.$route.name == 'Book'" class="crumb-item"><span @click="jumpHandle('/book')">整书列表</span></el-breadcrumb-item>
      <el-breadcrumb-item v-if="this.$route.name == 'Book' && this.$route.query.Province" class="crumb-item">{{this.$route.query.Province}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="this.$route.query.CategoryB && this.$route.name == 'Entry'" class="crumb-item">{{this.$route.query.CategoryB}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="total-num">共计&nbsp;<span>{{totalItems | formatNumber}}</span>&nbsp;条数据</div>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',
  props: {
    totalItems: Number
  },
  computed: {
  },
  methods: {
    async handleToBack() {
      if (await this.$loginAuthentication.intercept(0)) {
        const CategoryA = this.$route.query.CategoryA
        const totalIndex = this.$route.query.totalIndex
        this.$router.replace({
          path: 'entry',
          query: {
            CategoryA: CategoryA || '',
            totalIndex: totalIndex || '',
            Province: ''
          }
        })
      }
    },
    //点击跳转整书 条目 浏览
    async jumpHandle(path) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$router.push({
          path: path,
        });
      }
    }
  },
  filters: {
    formatNumber (val) {
      return parseFloat(val).toLocaleString()
    }
  }
}
</script>

<style lang="less" scoped>
.bread-crumb {
  margin-bottom: 18px;
  overflow: hidden;
  margin-right: 9px;
  line-height: 21px;
  width: 866px;
  .currentPosition {
    float: left;
    height: 21px;
    line-height: 21px;
  }
  .crumb-item {
    color: #333333;
    font-size: 14px;
    height: 21px;
    line-height: 21px;
    /deep/.el-breadcrumb__inner {
      color: #333333;
      font-weight: 400;
      cursor: pointer;
      &:hover {
        color: #1743A5;
        text-decoration-color: none;
      }
    }
    &:hover {
      color: #1743A5;
      text-decoration-line: underline;
    }
  }
  .bread-item {
    float: left;
  }
  .total-num {
    float: right;
    font-size: 14px;
    color: #333;
    span {
      color: #1743A5;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BreadCrumb/BreadCrumb.vue